import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WhatsappMsgToExpiredChatPageRoutingModule } from './whatsapp-msg-to-expired-chat-routing.module';

import { WhatsappMsgToExpiredChatPage } from './whatsapp-msg-to-expired-chat.page';
import { ComponentsModule } from 'src/components/components.module';
import { CommonLibModule } from 'common-lib';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    WhatsappMsgToExpiredChatPageRoutingModule,
    
    ComponentsModule,
    CommonLibModule,
    FormsModule,
  ],
  declarations: [WhatsappMsgToExpiredChatPage]
})
export class WhatsappMsgToExpiredChatPageModule {}
